// action types
import ApiService from "../../api.service";
import {SET_ERROR} from "../auth.module";
export const CUSTOMER_LIST = "customer/list";
export const CUSTOMER_CREATE = "customer/create";
export const CUSTOMER_FIND = "customer/find";
export const CUSTOMER_FIND_RE_REGISTER = "customer/check-re-register";
export const CUSTOMER_CHECK_RE_DISPUTE = "customer/check-dispute";
export const CUSTOMER_UPDATE = "customer/update";
export const CENTER_LIST = "customer/list-center";
export const BRANCH_LIST = "customer/list-branch";
export const LICH_TRUC_TU_VAN = "customer/lich-truc-tu-van";
export const DOI_TU_VAN_VIEN = "customer/doi-tu-van-vien";
export const DAT_LICH_TU_VAN = "customer/dat-lich-tu-van";
export const DAT_LICH_DOI = "customer/dat-lich-doi";
export const CHECK_BEFORE_CONSULT_SCHEDULE = "customer/check-before-consult-schedule";
export const GET_INFO_PAYMENT_SCHEDULE = "customer/get-info-payment-schedule";
export const PAYMENT_SCHEDULE = "customer/payment-schedule";
export const NHAP_KET_QUA_TU_VAN = "customer/nhap-ket-qua-tu-van";
export const CUSTOMER_DESTROY = "customer/destroy";
export const LIST_TUITION_PAYMENT_METHOD = 'customer/tuitionPayments';
export const LIST_INSTALLMENT_METHOD = 'customer/installmentMethods';
export const STORE_INSTALLMENT_INFORMATION = 'customer/installmentInformation'
export const UPDATE_INSTALLMENT_INFORMATION = 'customer/installmentInformation/update'
export const CUSTOMER_CONSULT_RESULT = "customer/consult-result";
export const GET_RESULT_TEST_INPUT = "contract-online/get-result-test-input";
export const CUSTOMER_CHECK_KH_PHAN_VAN = "customer/check-customer-phan-van";
export const CUSTOMER_UPDATE_LEVEL = "customer/update-level";
export const GET_CUSTOMER_BY_PHONE = "customer/get-customer-by-phone";

export const GET_TESTERT = "customer/get-testert";
export const GET_INPUT_SCHEDULE = "customer/input_schedule";
export const GET_DETAIL_CUSTOMER_FINANCE = "customer/detail/finance"
export const GET_DETAIL_CUSTOMER_STUDY = "customer/detail/study"
export const DETAIL_TEST_STUDENT = "customer/detail-test-student"
export const DETAIL_EXAM_RETAKES = "customer/detail-student-exam-retakes"
export const GET_DATA_TICKET_CUSTOMER = "customer/detail/ticket"
export const GET_DATA_TICKET_CATEGORY = "customer/ticket-category"
export const GET_DATA_HISTORY_CUSTOMER = "customer/history"
export const CUSTOMER_INFORMATION = "customer/user";
export const GET_TEST_INPUT_USER = "customer/test-input";
export const GET_TEST_RESULT = "customer/study-result";
export const GET_USER_PARENT = "customer/user-parent";
export const GET_POLICY = "contract-online/get_policy_contract";
export const CUSTOMER_SCHEDULE_LIST = "customer/customers/show/schedule";
export const GET_TEACHER_COMMENT = "customer/customers/get-teacher-comment";
export const INPUT_AMOUNT = "import-sales/store";
export const CHANGE_INPUT_AMOUNT = "import-sales/change-input-amount";
export const GET_HISTORY_SALE_IMPORT = "import-sales/history";
export const DELETE_IMPORT_AMOUNT = "import-sales/destroy";
export const GET_IMPORT_SALE_EXPECTED_LIST = "import-sales/expected";
export const CUSTOMER = "customer/customers/show/schedule";
export const GET_REGIONS_BY_USER = "branch/get-regions-by-user";
export const CHANGE_LEVEL_1E = "customer/change-level-1e";
export const EXPORT_CUSTOMER_LIST = "customer/export-customer";
export const CREATE_CUSTOMER_NOTE = "customer/create-note";
export const UPDATE_CUSTOMER_NOTE = "customer/update-note";
export const GET_CUSTOMER_NOTE = "customer/get-customer-note";
export const DELETE_CUSTOMER_NOTE = "customer/delete-customer-note";
export const IMPORT_CUSTOMER_EXCEL = "customer/import-customer";
export const GET_CUSTOMER_BY_USER = "customer/get-customer-by-user";
export const GET_CUSTOMER_SUPPORT = "customer/customer-need-support";
export const CREATE_TASK_WITH_CUSTOMER = "customer/create-task-with-customer";
export const GET_TASK_WITH_CUSTOMER = "customer/task-with-customer";
export const SEND_PROMOTION_EMAIL = "customer/send-promotion-email";
export const CHANGE_STATUS_TASK = "customer/status-task";
export const GET_TASK_SALE = "customer/task-sale";
export const CREATE_INPUT_RESULT_TASK = "customer/create-input-result-task";
export const GET_TASK_BY_SALE = "customer/get-task-by-sale";
export const GET_CHART_DATA = "customer/get-chart-data";
export const GET_CUSTOMER_CHART_BY_CENTER = "customer/get-customer-chart-by-center";
export const GET_PARENT = "customer/parent";
export const UPDATE_CONTENT_TASK = "customer/update-content-task";
export const CHECK_PERSONAL_EDUTALK = "customer/check-personal-edutalk";
export const CHANGE_WARRANTY_CONDITION = "customer/change-warranty-condition";
export const GET_SCHOOL_LIST = "affiliated-school"
export const STAGE_REVIEW_DETAIL = "customers/stage-review-detail"
export const END_COURSE_ASSESSMENT_DETAIL = "customers/end-course-assessment-detail"

// mutation types

// state types
const state = {
    config_customer: ''
};

const getters = {};

const actions = {
    [CUSTOMER_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${CUSTOMER_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CUSTOMER_CREATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CUSTOMER_CREATE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_CUSTOMER_NOTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${GET_CUSTOMER_NOTE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_TEACHER_COMMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${GET_TEACHER_COMMENT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [STAGE_REVIEW_DETAIL](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${STAGE_REVIEW_DETAIL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [END_COURSE_ASSESSMENT_DETAIL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${END_COURSE_ASSESSMENT_DETAIL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },


    [CREATE_CUSTOMER_NOTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CREATE_CUSTOMER_NOTE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [UPDATE_CUSTOMER_NOTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${UPDATE_CUSTOMER_NOTE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [DELETE_CUSTOMER_NOTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${DELETE_CUSTOMER_NOTE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [IMPORT_CUSTOMER_EXCEL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${IMPORT_CUSTOMER_EXCEL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CUSTOMER_FIND](context, id) {
        return new Promise(resolve => {
            ApiService.get(`/${CUSTOMER_FIND}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CUSTOMER_FIND_RE_REGISTER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${CUSTOMER_FIND_RE_REGISTER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CUSTOMER_CHECK_RE_DISPUTE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${CUSTOMER_CHECK_RE_DISPUTE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CUSTOMER_UPDATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CUSTOMER_UPDATE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [BRANCH_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${BRANCH_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CENTER_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${CENTER_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [LICH_TRUC_TU_VAN](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${LICH_TRUC_TU_VAN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [DOI_TU_VAN_VIEN](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${DOI_TU_VAN_VIEN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [DAT_LICH_TU_VAN](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${DAT_LICH_TU_VAN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [DAT_LICH_DOI](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${DAT_LICH_DOI}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CHECK_BEFORE_CONSULT_SCHEDULE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CHECK_BEFORE_CONSULT_SCHEDULE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_INFO_PAYMENT_SCHEDULE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${GET_INFO_PAYMENT_SCHEDULE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [PAYMENT_SCHEDULE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${PAYMENT_SCHEDULE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [NHAP_KET_QUA_TU_VAN](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${NHAP_KET_QUA_TU_VAN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },
    [CUSTOMER_DESTROY](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CUSTOMER_DESTROY}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
      [NHAP_KET_QUA_TU_VAN](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${NHAP_KET_QUA_TU_VAN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    /**
     * danh sách hình thức thanh toán học phí
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [LIST_TUITION_PAYMENT_METHOD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${LIST_TUITION_PAYMENT_METHOD}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },

    /**
     * danh sách tình trạng trả góp
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [LIST_INSTALLMENT_METHOD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${LIST_INSTALLMENT_METHOD}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },

    /**
     * tạo thông tin trả góp
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [UPDATE_INSTALLMENT_INFORMATION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${STORE_INSTALLMENT_INFORMATION}/${payload.id}` + '?_method=PUT', payload.params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },

    /**
     * cập nhật thông tin trả góp
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [STORE_INSTALLMENT_INFORMATION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${STORE_INSTALLMENT_INFORMATION}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },
    /**
     * Nhập kết quả tư vấn
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CUSTOMER_CONSULT_RESULT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/${CUSTOMER_CONSULT_RESULT}/${payload.id}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_RESULT_TEST_INPUT](context, customerId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/${GET_RESULT_TEST_INPUT}`, customerId)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Check nếu khách hàng phân vân(3E và của sale khác) thì không được taạo phiếu đăng ký
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CUSTOMER_CHECK_KH_PHAN_VAN](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CUSTOMER_CHECK_KH_PHAN_VAN}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CUSTOMER_UPDATE_LEVEL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CUSTOMER_UPDATE_LEVEL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_CUSTOMER_BY_PHONE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_CUSTOMER_BY_PHONE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_DETAIL_CUSTOMER_FINANCE](context, id) {
        return new Promise(resolve => {
            ApiService.get(`/${GET_DETAIL_CUSTOMER_FINANCE}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },


    [GET_TESTERT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_TESTERT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_DATA_TICKET_CUSTOMER](context, id) {
        return new Promise(resolve => {
            ApiService.get(`/${GET_DATA_TICKET_CUSTOMER}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_DATA_TICKET_CATEGORY](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_DATA_TICKET_CATEGORY}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_INPUT_SCHEDULE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_INPUT_SCHEDULE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [GET_DATA_HISTORY_CUSTOMER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_DATA_HISTORY_CUSTOMER}/${payload.id}`, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },
    [GET_DETAIL_CUSTOMER_STUDY](context, id) {
        return new Promise(resolve => {
            ApiService.get(`/${GET_DETAIL_CUSTOMER_STUDY}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [CUSTOMER_INFORMATION](context, id) {
      return new Promise((resolve) => {
        ApiService.get(`/${CUSTOMER_INFORMATION}`, id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            resolve(response);
            context.commit(
              SET_ERROR,
              response && response.data ? response.data.message : ""
            );
          });
      });
    },
    [GET_TEST_INPUT_USER](context, id) {
        return new Promise(resolve => {
          ApiService.query(`${GET_TEST_INPUT_USER}/${id}`, {}).then(({data}) => {
            resolve(data);
          }).catch((response) => {
          });
        })
    },
    [GET_TEST_RESULT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`${GET_TEST_RESULT}/${payload.id}`, {}).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },
    [GET_USER_PARENT](context, id) {
        return new Promise((resolve) => {
            ApiService.query(`/${GET_USER_PARENT}/${id}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    resolve(response);
                    context.commit(
                        SET_ERROR,
                        response && response.data ? response.data.message : ""
                    );
                });
        });
    },
    [GET_POLICY](context,id) {
        return new Promise((resolve) => {
            ApiService.get(`/${GET_POLICY}`,id)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    resolve(response);
                    context.commit(
                        SET_ERROR,
                        response && response.data ? response.data.message : ""
                    );
                });
        });
    },
    [CUSTOMER_SCHEDULE_LIST](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${CUSTOMER_SCHEDULE_LIST}/${id}`).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        })
    },

    [INPUT_AMOUNT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${INPUT_AMOUNT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                    // resolve(response);
                    // context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [DETAIL_TEST_STUDENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${DETAIL_TEST_STUDENT}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        })
    },

    [DETAIL_EXAM_RETAKES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${DETAIL_EXAM_RETAKES}`, payload).then(({data}) => {
                resolve(data)
            }).catch(({response}) => {
                reject(response);
            });
        })
    },

    [GET_INPUT_SCHEDULE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_INPUT_SCHEDULE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [DELETE_IMPORT_AMOUNT](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${DELETE_IMPORT_AMOUNT}`, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
            });
        })
    },

    [GET_HISTORY_SALE_IMPORT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_HISTORY_SALE_IMPORT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

     [GET_IMPORT_SALE_EXPECTED_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_IMPORT_SALE_EXPECTED_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
     },

    [GET_REGIONS_BY_USER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_REGIONS_BY_USER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CHANGE_LEVEL_1E](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CHANGE_LEVEL_1E}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CHANGE_INPUT_AMOUNT](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CHANGE_INPUT_AMOUNT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [EXPORT_CUSTOMER_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${EXPORT_CUSTOMER_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_CUSTOMER_BY_USER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_CUSTOMER_BY_USER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_PARENT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_PARENT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CREATE_TASK_WITH_CUSTOMER](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CREATE_TASK_WITH_CUSTOMER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_CUSTOMER_SUPPORT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_CUSTOMER_SUPPORT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_TASK_WITH_CUSTOMER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_TASK_WITH_CUSTOMER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [SEND_PROMOTION_EMAIL](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${SEND_PROMOTION_EMAIL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CHANGE_STATUS_TASK](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CHANGE_STATUS_TASK}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_TASK_SALE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_TASK_SALE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_TASK_SALE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_TASK_SALE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CREATE_INPUT_RESULT_TASK](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${CREATE_INPUT_RESULT_TASK}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_TASK_BY_SALE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_TASK_BY_SALE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_CHART_DATA](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_CHART_DATA}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_CUSTOMER_CHART_BY_CENTER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_CUSTOMER_CHART_BY_CENTER}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [UPDATE_CONTENT_TASK](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`/${UPDATE_CONTENT_TASK}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [CHECK_PERSONAL_EDUTALK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${CHECK_PERSONAL_EDUTALK}`, payload).then(({data}) => {
                resolve(data)
            }).catch(({response}) => {
                reject(response);
            });
        })
    },

    [CHANGE_WARRANTY_CONDITION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CHANGE_WARRANTY_CONDITION}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    reject(response);
                });
        });
    },

    [CHECK_PERSONAL_EDUTALK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${CHECK_PERSONAL_EDUTALK}`, payload).then(({data}) => {
                resolve(data)
            }).catch(({response}) => {
                reject(response);
            });
        })
    },
    [GET_SCHOOL_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`${GET_SCHOOL_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
